import React, { useEffect, useState } from 'react';
import {
  Button,
  Spin,
  Modal,
  Form,
  Input,
  Radio,
  Select,
  notification,
} from 'antd';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';
import map from 'lodash/map';
import find from 'lodash/find';
import { LeftOutlined, PlusOutlined } from '@ant-design/icons';
import { productMangement } from '../../redux/actions/productAction';

const { Option } = Select;

function AddProductNutrition(props) {
  const { onSelectNutrition, selectedNutritions, companyId } = props;
  const [showLoginModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nutritions, setNutritions] = useState([]);
  const [section, setSection] = useState(1);
  const dispatch = useDispatch();

  const toggleModal = () => {
    setShowModal(!showLoginModal);
  };

  const onSelectFinish = ({ id }) => {
    if (find(selectedNutritions, ['id', id])) {
      notification.error({
        message: 'This nutrition is already selected!',
      });
      return;
    }
    onSelectNutrition(find(nutritions, ['id', id]));
    toggleModal();
  };

  const onCreateFinish = (value) => {
    setLoading(true);
    dispatch(
      productMangement('create.product_nutrition_type', {
        company_id: companyId,
        ...value,
      })
    )
      .then((result) => {
        onSelectNutrition(get(result, 'data'));
        toggleModal();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getNutrition = () => {
    setLoading(true);
    dispatch(
      productMangement('list.product_nutrition_types', {
        company_id: companyId,
      })
    )
      .then((result) => {
        setNutritions(get(result, 'data'));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (showLoginModal) {
      getNutrition();
    }
  }, [showLoginModal]);

  return (
    <>
      <Button
        className="add-categoty-link"
        icon={<PlusOutlined />}
        onClick={toggleModal}
        type="link"
      >
        Add Nutrition
      </Button>
      <Modal
        width="50%"
        className="common-modal product-image-modal "
        destroyOnClose
        closable={false}
        open={showLoginModal}
        onOk={toggleModal}
        onCancel={toggleModal}
        footer={null}
        maskClosable={false}
      >
        <Spin spinning={loading}>
          <div className="login-container">
            <div className="heading">
              <LeftOutlined
                className="back-btn"
                onClick={() => {
                  toggleModal();
                }}
              />
              Add Nutrition
            </div>
            <div className=" add-ingredient mt-40">
              <Radio.Group
                defaultValue={section}
                buttonStyle="solid"
                className="radio-btn"
                onChange={(e) => {
                  setSection(get(e, 'target.value'));
                }}
              >
                <Radio.Button value={1}>Select Nutrition</Radio.Button>
                <Radio.Button value={2}>Create a new Nutrition</Radio.Button>
              </Radio.Group>
              {section === 1 && (
                <Form
                  name="basic"
                  layout="vertical"
                  initialValues={{ remember: true }}
                  onFinish={onSelectFinish}
                  autoComplete="off"
                  requiredMark={false}
                >
                  <div className="mt-20">
                    <Form.Item
                      label="Ingredient"
                      name="id"
                      className="form-item"
                      rules={[
                        {
                          required: true,
                          message: 'Please select a ingredient!',
                        },
                      ]}
                    >
                      <Select placeholder="Select Nutrition" size="large">
                        {map(nutritions, (nutrition) => (
                          <Option
                            key={get(nutrition, 'id')}
                            value={get(nutrition, 'id')}
                            label={get(nutrition, 'name')}
                          >
                            {get(nutrition, 'name')}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <div className="mt-40">
                      <Button type="primary" block htmlType="submit">
                        Select
                      </Button>
                    </div>
                  </div>
                </Form>
              )}

              {section === 2 && (
                <Form
                  name="basic"
                  layout="vertical"
                  onFinish={onCreateFinish}
                  autoComplete="off"
                  requiredMark={false}
                >
                  <div className="mt-20">
                    <Form.Item
                      label="Nutrition Name"
                      name="name"
                      className="form-item"
                      rules={[
                        {
                          required: true,
                          message: 'Please input nutrition name!',
                        },
                        {
                          min: 3,
                          message:
                            'Nutrition name  should be of atleast 3 character!',
                        },
                      ]}
                    >
                      <Input size="large" placeholder="Enter Nutrition" />
                    </Form.Item>
                  </div>

                  <div className="mt-40">
                    <Button type="primary" block htmlType="submit">
                      Create
                    </Button>
                  </div>
                </Form>
              )}
            </div>
          </div>
        </Spin>
      </Modal>
    </>
  );
}

export default AddProductNutrition;
